import { Component, OnInit, Input, HostBinding } from '@angular/core';

@Component({
  selector: 'app-table-column',
  templateUrl: './table-column.component.html',
  styleUrls: ['./table-column.component.scss']
})
export class TableColumnComponent implements OnInit {

  @Input() systemId: string;
  @Input() subSystemId: string = null;
  @Input() width: string;
  @HostBinding('style.width') hostWidth: string;
  @HostBinding('style.flex') hostFlex: string;

  constructor() { }

  ngOnInit() {
    this.hostWidth = this.width;
    this.hostFlex = '1 0 ' + this.width;
  }

}



// WEBPACK FOOTER //
// ./src/app/components/table-column/table-column.component.ts